import React from 'react'

export const Field = ({ label, required, hint, className = '', children }) => (
	<div className={`flex flex-col gap-1.5 ${className}`}>
		<label className="text-[12px] font-medium text-slate-500">
			{label}
			{required && <span className="ml-0.5 text-rose-500">*</span>}
		</label>
		{children}
		{hint && <span className="text-[11px] text-slate-400">{hint}</span>}
	</div>
)

export const Card = ({ title, subtitle, right, className = '', children }) => (
	<section
		className={`rounded-2xl border border-slate-200 bg-white p-4 sm:p-5 ${className}`}
	>
		{(title || right) && (
			<div className="mb-4 flex flex-wrap items-center justify-between gap-3">
				<div>
					{title && (
						<h2 className="text-[15px] font-semibold text-slate-900">{title}</h2>
					)}
					{subtitle && (
						<p className="mt-0.5 text-[12px] text-slate-400">{subtitle}</p>
					)}
				</div>
				{right}
			</div>
		)}
		{children}
	</section>
)

export const InfoItem = ({ label, value, className = '' }) => (
	<div className={`flex flex-col gap-0.5 ${className}`}>
		<span className="text-[11px] uppercase tracking-wide text-slate-400">
			{label}
		</span>
		<span className="text-sm font-medium text-slate-800">{value}</span>
	</div>
)
